export const CARD_TITLE_TEST_ID = 'information-card-qc-title'
export const CARD_CONTENT_ITEM_TEST_ID = 'information-card-qc-content-item'
